import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Divider } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useGetVehicleListingDetailQuery } from "store/services/vehicleListingApi";
import {
  VehicleListingDetailContext,
  useVehicleListingDetailContext,
} from "contexts/VehicleListingDetailContext";
import VehicleListingBasicDetail from "./vehicleListingComponents/VehicleListingBasicDetail";

const VehicleListingDetailScreen = () => {
  const { id } = useParams();

  const breadcrumbs = [
    { title: "External Driver Record", path: "/app/crm/vehicle-listing/list" },
    { title: "External Driver Record Detail" },
  ];

  const {
    data: vehicleListingDetail,
    isLoading: loadingVehicleListing,
    error,
  } = useGetVehicleListingDetailQuery(id);

  return (
    <VehicleListingDetailContext.Provider
      value={{ vehicleListingDetail, loadingVehicleListing }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingVehicleListing}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />
        <BreadcrumbLayout.Paper>
          <VehicleListingBasicDetail />
          <Divider />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </VehicleListingDetailContext.Provider>
  );
};

export default VehicleListingDetailScreen;

const PageActions = () => {
  const { vehicleListingDetail } = useVehicleListingDetailContext();

  return (
    <div className="flex items-center gap-4">
      <Link to={`/app/crm/vehicle-listing/${vehicleListingDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};